import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import type {
  TPostGenerateContractorPayStatementFileRequest,
  TPostGenerateContractorPayStatementFileResponse,
} from "./postGenerateContractorPayStatementFile.schema";

export const postGenerateContractorPayStatementFile = (
  axios: IAxiosInstance
) => {
  return async (
    requestBody: TPostGenerateContractorPayStatementFileRequest
  ): Promise<string> => {
    const response =
      await axios.noRetry.post<TPostGenerateContractorPayStatementFileResponse>(
        "/reports/create/contractor-pay-statement",
        requestBody
      );

    if (response.data.success) {
      return response.data.data;
    }

    throw new Error("Something went wrong generating contractor pay statement");
  };
};
